import React, { useState } from 'react'
import * as UI from 'konsys-ui'
import _ from 'lodash'
import { Query } from 'react-apollo'
import {
  Col, Upload, Select, Input, Spin,
} from 'antd'
import { GET_CLIENTS, GET_SENDERS, GET_RECEIVERS } from '../../../constants/graphql/query'
import {
  detailMode, unitVar, unitValue, unitText,
} from '../constants'
// import { checkInt, checkFloat } from '../../../utils/util-services'
import { InputWithLabelBlock, DropdownWithLabel } from '../../../components/common/components-group'
import { UploadWithModal } from '../../../components/common'

/*
date.type is type of component
0: InputWithLabel
1: input
2: Text (P)
3: Dropdown (Select)
4: Upload
5: Datepicker
6: TextArea
*/
export const mappingValueToText = (value) => {
  switch (value) {
    case unitValue.TON: return unitText.TON
    case unitValue.KG: return unitText.KG
    case unitValue.H50: return unitText.H50
    case unitValue.TRIP: return unitText.TRIP
    // case unitValue.H60: return unitText.H60
    // case unitValue.H100: return unitText.H100
    default: return 'เลือกหน่วย'
  }
}

const CreateMode = ({
  data, onChangeHandler, client, mutationVariables, loadingLastPrice,
}) => {
  const [name, setName] = useState('')
  if (data.id === 'deliveredWeight') return ''
  const [id, setID] = useState('')
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span}>
          <UI.Div display='flex' alignItems='flex-end'>
            <InputWithLabelBlock
              data={{
                props: { ...data.props },
                value: mutationVariables[data.id],
                id: data.id,
              }}
              onChangeHandler={(key, value) => {
                onChangeHandler(key, value)
              }}
              isFloat={_.includes(['feeRate', 'predealPrice', 'truckOwnerFeeRate', 'distance'], data.id)}
              isInt={_.includes(['contractWeight'], data.id)}
            />
            {
              (data.id === 'feeRate' || data.id === 'distance') && loadingLastPrice && <UI.Loading size='small' style={{ margin: '0 16px 24px' }} />
            }
          </UI.Div>
        </Col>
      )
    case 1:
      return (
        <Col span={data.span}>
          <UI.Input {...data.props} />
        </Col>
      )
    case 2:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props} margin={_.isUndefined(client.clientInfo[data.id]) ? '0 0 48px' : data.props.margin}>{data.label}</UI.P>
          <UI.P {...data.props}>{client.clientInfo[data.id]}</UI.P>
        </Col>
      )
    case 3:
      return (
        <Col span={data.span}>
          <UI.P margin='0 0 16px' display='block' {...data.props}>{data.label}</UI.P>
          <Select
            defaultValue={data.id === 'unit' ? 'ตัน' : 'ต่อน้ำหนัก'}
            style={{ width: '100%' }}
            onChange={e => onChangeHandler(data.id, e)}
            disabled={data.disabled}
          >
            {
              data.children.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
            }
          </Select>
        </Col>
      )
    case 4:
      return (
        <Col span={data.span}>
          <UploadWithModal
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => v.originFileObj))}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    case 5:
      return (
        <Col span={data.span}>
          <UI.P margin='0 0 16px' display='block' {...data.props}>{data.label}</UI.P>
          <Select
            style={{ width: '100%' }}
            disabled={true}
            value={mutationVariables.dealType === 'PERWEIGHT' ? 'ตัน' : 'เที่ยว'}
          >
            {
              data.children.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
            }
          </Select>
        </Col>
      )
    case 6:
      return (
        <Col span={data.span}>
          <UI.P {...data.props} display='block' margin='0 0 16px'>{data.label}</UI.P>
          <Input.TextArea rows={4} style={{ margin: '0 0 16px' }} onChange={e => onChangeHandler(data.id, e.target.value)} />
        </Col>
      )
    case 7: // customerlist query only
      return <Col
        span={data.span}
      >
        <Query
          query={GET_CLIENTS}
          variables={{
            companyName: id,
            limit: 5,
            type: 'CLIENT',
          }}
        >{({ data: clientData, loading: clientLoading, error: clientError }) => {
          if (clientLoading && _.isEmpty(clientData)) return <UI.Loading center='true' />
          if (clientError) return <UI.P>เกิดข้อผิดพลาด</UI.P>

          const mappedData = clientData.getCustomerLists.lists.map(v => ({
            id: v.id, companyName: v.companyName, companyId: v.companyId, type: v.TypeOfCharge.name, branch: v.branch,
          }))
          return (
            <UI.Div display='flex' flexDirection='column' margin='0'>
              <UI.P margin='0 0 16px'>{data.label}</UI.P>
              <Select
                showSearch
                optionFilterProp="children"
                notFoundContent={clientLoading ? <Spin size="small" /> : null}
                onSearch={e => setID(e)}
                onChange={(e) => {
                  const clientObj = _.find(mappedData, o => o.id === e)
                  onChangeHandler('customerId', clientObj.id)
                  client.setClientHandler({ companyId: clientObj.companyId, typeOfCharge: clientObj.type, branch: clientObj.branch })
                }}
                onBlur={() => {
                  if (data.id === 'companyName') {
                    if (_.isUndefined(client.clientInfo.companyId)) setID('')
                  }
                }}
                style={{ width: '100%' }}
              >
                {
                  mappedData.map((v, i) => <Select.Option key={i} value={v.id}>{v.companyName}</Select.Option>)
                }
              </Select>
            </UI.Div>
          )
        }}
        </Query>
      </Col>
    case 9:
      return (<Col
        span={data.span}
        offset={data.offset}
      >
        <Query
          query={data.id === 'startDestination' ? GET_SENDERS : GET_RECEIVERS}
          variables={{
            name,
            limit: 5,
          }}
        >{({ data: respData, loading: respLoading, error: respError }) => {
          if (respLoading && _.isEmpty(respData)) return <UI.Loading center='true' />
          if (respError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
          const list = data.id === 'startDestination' ? respData.SenderLocationList.lists : respData.ReceiverLocationList.lists
          const mappedData = list.map(v => ({
            id: v.id, name: v.name, branch: v.branch,
          }))
          return (
            <UI.Div display='flex' flexDirection='column' margin='0'>
              <UI.P margin='0 0 16px'>{data.label}</UI.P>
              <Select
                loading={respLoading}
                showSearch
                optionFilterProp="children"
                notFoundContent={respLoading ? <Spin size="small" /> : null}
                onSearch={e => setName(e)}
                onChange={(e) => {
                  const clientObj = _.find(mappedData, o => o.id === e)
                  onChangeHandler(data.id, clientObj.id)
                  client.setClientHandler({ [`${data.id}Text`]: clientObj.branch })
                }}
                onBlur={() => {
                  if (data.id === 'startDestination') {
                    if (_.isUndefined(client.clientInfo.startDestination)) setName('')
                  } else if (data.id === 'endDestination') {
                    if (_.isUndefined(client.clientInfo.endDestination)) setName('')
                  }
                }}
                style={{ width: '100%' }}
              >
                {
                  mappedData.map((v, i) => <Select.Option key={i} value={v.id}>{v.name}</Select.Option>)
                }
              </Select>
            </UI.Div>
          )
        }}
        </Query>
      </Col>
      )
    case 10:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props}>{_.isUndefined(data.label) ? client.clientInfo[data.id] : data.label}</UI.P>
        </Col>
      )
    case 11:
      return (
        <Col span={data.span} offset={data.offset}>
          {/* <DropdownWithLabel
            options={unitVar}
            data={{
              disabled: mutationVariables.dealType === 'PERTRIP',
              value: mutationVariables.unit,
              id: 'unit',
              text: 'หน่วย *',
              placeholder: 'เลือกหน่วย',
              props: { margin: '0 16px 0 0', width: '100%' },
            }}
            onChangeHandler={(key, value) => onChangeHandler(key, value)}
            mappingValueToText={() => mappingValueToText(mutationVariables.unit)}
          /> */}
          <UI.Div display='flex' flexDirection='column' margin='0'>
            <UI.P margin='0 0 16px'>หน่วย *</UI.P>
            <Select
              disabled= {mutationVariables.dealType === 'PERTRIP'}
              placeholder='เลือกหน่วย'
              onChange={e => onChangeHandler('unit', e)}
              value= {mappingValueToText(mutationVariables.unit)}
              style={{ width: '100%' }}
            >
              {
                unitVar.map(v => <Select.Option key={v.value} value={v.value} disabled={v.disabled}>{v.text}</Select.Option>)
              }
            </Select>
          </UI.Div>
        </Col>
      )
    case 12:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props}>{`${data.label}: ${(_.isNil(mutationVariables[data.id]) || _.isNil(mutationVariables.availableOrder)) ? '-' : mutationVariables[data.id]}`}</UI.P>
        </Col>
      )
    case 13:
      return (
        <Col span={data.span}>
          <UI.Div display='flex' alignItems='flex-end'>
            <InputWithLabelBlock
              data={{
                props: { ...data.props },
                value: mutationVariables[data.id],
                id: data.id,
                disabled: mutationVariables.dealType === 'PERTRIP',
              }}
              onChangeHandler={(key, value) => {
                onChangeHandler(key, value)
              }}
              isFloat={true}
            />
          </UI.Div>
        </Col>
      )
    default:
      return <p>No type</p>
  }
}

const EditMode = ({
  data, onChangeHandler, client, disabled, jobInfo, mode, mutationVariables, loadingLastPrice,
  data: {
    onlyView,
  },
}) => {
  const [name, setName] = useState('')
  if (onlyView && mode !== detailMode.VIEW) return ('')
  const [id, setID] = useState('')
  switch (data.type) {
    case 0:
      // return (
      //   <Col span={data.span}>
      //     <InputWithLabelBlock
      //       data={{
      //         disabled,
      //         defaultValue: jobInfo[data.id],
      //         props: { ...data.props },
      //         value: mutationVariables[data.id],
      //         id: data.id,
      //       }}
      //       onChangeHandler={(key, value) => {
      //         onChangeHandler(key, value)
      //       }}
      //       isFloat={_.includes(['feeRate', 'contractWeight', 'predealPrice'], data.id)}
      //     />
      //   </Col>
      // )
      return (
        <Col span={data.span}>
          <UI.Div display='flex' alignItems='flex-end'>
            <InputWithLabelBlock
              data={{
                disabled,
                defaultValue: jobInfo[data.id],
                props: { ...data.props },
                value: mutationVariables[data.id],
                id: data.id,
              }}
              onChangeHandler={(key, value) => {
                onChangeHandler(key, value)
              }}
              isFloat={_.includes(['feeRate', 'predealPrice', 'truckOwnerFeeRate', 'distance'], data.id)}
              isInt={_.includes(['contractWeight'], data.id)}
            />
            {
              (data.id === 'feeRate' || data.id === 'distance') && loadingLastPrice && <UI.Loading size='small' style={{ margin: '0 16px 24px' }} />
            }
          </UI.Div>
        </Col>
      )
    case 1:
      return (
        <Col span={data.span}>
          <UI.Input {...data.props} disabled={disabled} defaultValue={jobInfo[data.id]} />
        </Col>
      )
    case 2:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props}>{data.label}</UI.P>
          <UI.P {...data.props}>{_.isEmpty(client.clientInfo) ? jobInfo.Customer[data.id] : client.clientInfo[data.id]}</UI.P>
        </Col>
      )
    case 3:
      return (
        <Col span={data.span}>
          <UI.P margin='0 0 16px' display='block' {...data.props} >{data.label}</UI.P>
          <Select
            disabled={disabled || (data.id === 'dealType') || data.disabled}
            defaultValue={!_.isUndefined(_.find(data.children, o => o.value === jobInfo[data.id])) && _.find(data.children, o => o.value === jobInfo[data.id]).text}
            style={{ width: '100%' }}
            onChange={e => onChangeHandler(data.id, e)}
          >
            {
              data.children.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
            }
          </Select>
        </Col>
      )
    case 4:
      return (
        <Col span={data.span}>
          <UploadWithModal
            onChange={e => onChangeHandler(data.id, e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))}
            showUploadList={{
              showRemoveIcon: !disabled,
            }}
            disabled={disabled}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            defaultFileList={jobInfo[data.id].map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            button={data.props}
            listType='picture'
          />
        </Col>
      )
    case 5:
      return (
        <Col span={data.span}>
          <UI.P margin='0 0 16px' display='block' {...data.props}>{data.label}</UI.P>
          <Select
            defaultValue={jobInfo.dealType === 'PERWEIGHT' ? 'ตัน' : 'เที่ยว'}
            style={{ width: '100%' }}
            disabled={true}
          >
            {
              data.children.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
            }
          </Select>
        </Col>
      )
    case 6:
      return (
        <Col span={data.span}>
          <UI.P {...data.props} display='block' margin='0 0 16px'>{data.label}</UI.P>
          <Input.TextArea defaultValue={jobInfo[data.id]} disabled={disabled} rows={4} style={{ margin: '0 0 16px' }} onChange={e => onChangeHandler(data.id, e.target.value)} />
        </Col>
      )
    case 7: // customerlist query only
      return <Col
        span={data.span}
      >
        <Query
          query={GET_CLIENTS}
          variables={{
            companyName: id,
            limit: 5,
            type: 'CLIENT',
          }}
        >{({ data: clientData, loading: clientLoading, error: clientError }) => {
          if (clientLoading && _.isEmpty(clientData)) return <UI.Loading center='true' />
          if (clientError) return <UI.P>เกิดข้อผิดพลาด</UI.P>

          const mappedData = clientData.getCustomerLists.lists.map(v => ({
            id: v.id, companyName: v.companyName, companyId: v.companyId, type: v.TypeOfCharge.name, branch: v.branch,
          }))
          return (
            <UI.Div display='flex' flexDirection='column' margin='0'>
              <UI.P margin='0 0 16px'>{data.label}</UI.P>
              <Select
                loading={clientLoading}
                defaultValue={jobInfo.Customer[data.id]}
                disabled={disabled}
                showSearch
                optionFilterProp="children"
                notFoundContent={clientLoading ? <Spin size="small" /> : null}
                onSearch={e => setID(e)}
                onChange={(e) => {
                  const clientObj = _.find(mappedData, o => o.id === e)
                  onChangeHandler('customerId', clientObj.id)
                  client.setClientHandler({ companyId: clientObj.companyId, typeOfCharge: clientObj.type, branch: clientObj.branch })
                }}
                onBlur={() => {
                  if (data.id === 'companyName') {
                    if (_.isUndefined(client.clientInfo.companyId)) setID('')
                  }
                }}
                style={{ width: '100%' }}
              >
                {
                  mappedData.map((v, i) => <Select.Option key={i} value={v.id}>{v.companyName}</Select.Option>)
                }
              </Select>
            </UI.Div>
          )
        }}
        </Query>
      </Col>
    case 8:
      return (
        <Col span={data.span} offset={data.offset} style={{ display: 'flex', flexDirection: 'column', ...data.props }}>
          <UI.P margin='0 0 22px'>{data.label}</UI.P>
          <UI.P margin='0 0 8px'>{jobInfo[data.id]}</UI.P>
        </Col>
      )
    case 9:
      return (<Col
        span={data.span}
        offset={data.offset}
      >
        <Query
          query={data.id === 'startDestination' ? GET_SENDERS : GET_RECEIVERS}
          variables={{
            name,
            limit: 5,
          }}
        >{({ data: respData, loading: respLoading, error: respError }) => {
          if (respLoading && _.isEmpty(respData)) return <UI.Loading center='true' />
          if (respError) return <UI.P>เกิดข้อผิดพลาด</UI.P>
          const list = data.id === 'startDestination' ? respData.SenderLocationList.lists : respData.ReceiverLocationList.lists
          const defaultValueName = data.id === 'startDestination' ? 'startDestinationLocation' : 'endDestinationLocation'
          const mappedData = list.map(v => ({
            id: v.id, name: v.name, branch: v.branch,
          }))
          return (
            <UI.Div display='flex' flexDirection='column' margin='0'>
              <UI.P margin='0 0 16px'>{data.label}</UI.P>
              <Select
                disabled={disabled}
                defaultValue={!_.isNull(jobInfo[defaultValueName]) && jobInfo[defaultValueName].name}
                loading={respLoading}
                showSearch
                optionFilterProp="children"
                notFoundContent={respLoading ? <Spin size="small" /> : null}
                onSearch={e => setName(e)}
                onChange={(e) => {
                  const clientObj = _.find(mappedData, o => o.id === e)
                  onChangeHandler(data.id, clientObj.id)
                  client.setClientHandler({
                    [`${data.id}Text`]: clientObj.branch,
                  })
                }}
                onBlur={() => {
                  if (data.id === 'startDestination') {
                    if (_.isUndefined(client.clientInfo.startDestination)) setName('')
                  } else if (data.id === 'endDestination') {
                    if (_.isUndefined(client.clientInfo.endDestination)) setName('')
                  }
                }}
                style={{ width: '100%' }}
              >
                {
                  mappedData.map((v, i) => <Select.Option key={i} value={v.id}>{v.name}</Select.Option>)
                }
              </Select>
            </UI.Div>
          )
        }}
        </Query>
      </Col>
      )
    case 10:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props}>{_.isUndefined(data.label) ? client.clientInfo[data.id] : data.label}</UI.P>
        </Col>
      )
    case 11:
      return (
        <Col span={data.span} offset={data.offset}>
          {/* <DropdownWithLabel
            options={unitVar}
            data={{
              disabled: mutationVariables.dealType === 'PERTRIP' || disabled,
              defaultValue: jobInfo.unit,
              value: mutationVariables.unit,
              id: 'unit',
              text: 'หน่วย *',
              placeholder: 'เลือกหน่วย',
              props: { margin: '0 16px 0 0', width: '100%' },
            }}
            onChangeHandler={(key, value) => onChangeHandler(key, value)}
            mappingValueToText={() => mappingValueToText(mutationVariables.unit)}
          /> */}
          <UI.Div display='flex' flexDirection='column' margin='0'>
            <UI.P margin='0 0 16px'>หน่วย *</UI.P>
            <Select
              disabled= {mutationVariables.dealType === 'PERTRIP' || disabled || (jobInfo.dealType === 'PERTRIP' && _.isEmpty(mutationVariables.dealType))}
              defaultValue= {mappingValueToText(jobInfo.unit)}
              placeholder='เลือกหน่วย'
              onChange={e => onChangeHandler('unit', e)}
              style={{ width: '100%' }}
            >
              {
                unitVar.map(v => <Select.Option key={v.value} value={v.value} disabled={v.disabled}>{v.text}</Select.Option>)
              }
            </Select>
          </UI.Div>
        </Col>
      )
    case 12:
      return (
        <Col span={data.span} offset={data.offset}>
          <UI.P {...data.props}>{`${data.label}: ${(_.isNil(mutationVariables[data.id]) || _.isNil(mutationVariables.availableOrder)) ? '-' : mutationVariables[data.id]}`}</UI.P>
        </Col>
      )
    case 13:
      return (
        <Col span={data.span}>
          <UI.Div display='flex' alignItems='flex-end'>
            <InputWithLabelBlock
              data={{
                props: { ...data.props },
                value: mutationVariables[data.id],
                defaultValue: jobInfo[data.id],
                id: data.id,
                disabled: disabled || mutationVariables.dealType === 'PERTRIP',
              }}
              onChangeHandler={(key, value) => {
                onChangeHandler(key, value)
              }}
              isFloat={true}
            />
          </UI.Div>
        </Col>
      )
    default:
      return <p>No type</p>
  }
}

export default ({
  data, mode, onChangeHandler, client, jobInfo, mutationVariables, loadingLastPrice,
}) => {
  const mappedJob = mode === detailMode.ADD ? {} : {
    ...jobInfo,
    Customer: {
      ...jobInfo.Customer,
      typeOfCharge: jobInfo.Customer.TypeOfCharge.name,
    },
  }
  switch (mode) {
    case detailMode.ADD:
      return <CreateMode data={data} onChangeHandler={onChangeHandler} client={client} mutationVariables={mutationVariables} loadingLastPrice={jobInfo} />
    case detailMode.EDIT:
      return <EditMode data={data} onChangeHandler={onChangeHandler} client={client} jobInfo={mappedJob} mutationVariables={mutationVariables} loadingLastPrice={loadingLastPrice} />
    case detailMode.VIEW:
      return <EditMode data={data} disabled={true} onChangeHandler={onChangeHandler} client={client} jobInfo={mappedJob} mutationVariables={mutationVariables} loadingLastPrice={loadingLastPrice} />
    default:
      return <p>no mode</p>
  }
}
